export class J3Overlay {
    overlay:HTMLElement;
    imagePanel:HTMLElement;

    constructor(){
        //let container = document.querySelector('#container') as HTMLElement;
        //container.style.display = 'none';

        this.overlay = document.querySelector('#overlay') as HTMLElement;
        this.ShowOverlay();
        /*
        this.imagePanel = document.querySelector('#image .popup') as HTMLElement;
        if(this.imagePanel) {
            const btn_imagePanel_close = document.querySelector('#image .popup .close button') as HTMLElement;
            //btn_imagePanel_close.style.display = 'none';
            btn_imagePanel_close.addEventListener("click", (e: Event) => {
                this.HideImagePanel();
            });
            this.ShowImagePanel();
        }
        */
    }

    ShowOverlay(){
        if(this.overlay) {
            this.overlay.style.visibility = 'visible';
            this.overlay.style.display = 'block';
            this.overlay.style.pointerEvents = 'none';
        }
    }
    HideOverlay(){
        if(this.overlay) {
            this.overlay.style.visibility = 'hidden';
            this.overlay.style.display = 'none';
            this.overlay.style.pointerEvents = 'none'
        }
    }
    ToggleOverlay(){
        if(this.overlay) {
            if(this.overlay.style.display == 'none'){
                this.ShowOverlay();
            }else{
                this.HideOverlay();
            }
        }
    }

    ShowImagePanel(){
        if(this.imagePanel) {
            this.imagePanel.style.visibility = 'visible';
            this.imagePanel.style.display = 'block';
            this.imagePanel.style.pointerEvents = 'all';
        }
    }

    HideImagePanel(){
        if(this.imagePanel) {
            this.imagePanel.style.visibility = 'hidden';
            this.imagePanel.style.display = 'none';
            this.imagePanel.style.pointerEvents = 'none';
        }
    }

    ToggleImagePanel(){
        if(this.imagePanel) {
            if(this.imagePanel.style.display == 'none'){
                this.ShowImagePanel();
            }else{
                this.HideImagePanel();
            }
        }
    }
}